<div class="container text-center pagetopmrg">
    <div class="coming-soon-content">
      <h1>Coming Soon</h1>
      <p>We're working hard to get this page ready for you. Stay tuned!</p>
      <button class="btn btn-secondary" (click)="goBack()">Back</button>
    </div>
  </div>
  